import { render, staticRenderFns } from "./NavbarInfo.vue?vue&type=template&id=524ee80e&scoped=true"
import script from "./NavbarInfo.vue?vue&type=script&lang=js"
export * from "./NavbarInfo.vue?vue&type=script&lang=js"
import style0 from "./NavbarInfo.vue?vue&type=style&index=0&id=524ee80e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524ee80e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('524ee80e')) {
      api.createRecord('524ee80e', component.options)
    } else {
      api.reload('524ee80e', component.options)
    }
    module.hot.accept("./NavbarInfo.vue?vue&type=template&id=524ee80e&scoped=true", function () {
      api.rerender('524ee80e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NavbarInfo.vue"
export default component.exports